<div class="!h-[calc(100vh-90px)] custom-scrollbar overflow-scroll w-fit mx-auto" *transloco="let t;prefix:'auth'">
    <div class="px-2 aspect43:px-10 aspect43:flex gap-[50px] pt-5">
        <div class="aspect43:border-r-[2px] aspect43:border-primary px-0 aspect43:px-5">
        <div title class="text-font26px aspect43:text-font63px text-center text-quaternary mt-[10px] mb-5 md:mb-[54px]">
            Modifica le informazioni
        </div>

<std-button (click)="showPassword = true" id="button-login" size="sm"
                buttonClass="bg-quaternary mb-2.5 rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Cambia password</std-button>

        @if(role == 1 || role == 5) {
        <div class="ml-auto w-full mt-5">
            @if(outlookAccessToken == null) {
            <std-button (click)="connectOutlook()" id="button-login" size="sm"
                buttonClass="bg-quaternary rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Connetti
                Outlook</std-button>
            } @else {
            <std-button (click)="disconnectOutlook()" id="button-login" size="sm"
                buttonClass="bg-secondary rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Disconnetti
                Outlook</std-button>
            }
        </div>
        }
        @else {
        <div id="scroll-inputs"
            class="md:min-w-[400px] justify-center place-content-start aspect43:flex overflow-x-hidden aspect43:flex-wrap aspect43:gap-5 mb-5 overflow-y-scroll custom-scroll mx-auto">
            
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                [(ngModel)]="completeData.firstName" [value]="completeData?.firstName"
                customLabel="label-input" [label]="'Nome*'" [placeholder]="'Inserisci nome'"
                customContainerlass="mb-8" type="text">
            </std-input>


            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                [(ngModel)]="completeData.lastName" [value]="completeData?.lastName"
                customLabel="label-input" [label]="'Cognome*'" [placeholder]="'Inserisci cognome'"
                customContainerlass="mb-8" type="text">
            </std-input>
            
            <std-input labelPosition="top" customInputClass="custom-input pointer-events-none opacity-75 md:!min-w-[400px]"
               [value]="email"
                customLabel="label-input" [label]="'Email*'" [placeholder]="'Inserisci email'"
                customContainerlass="mb-8" type="text" >
            </std-input>
            @if(role != 7){<div class="pointer-events-none opacity-75"><std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                [(ngModel)]="completeData.ragioneSociale" [value]="completeData?.ragioneSociale"
                customLabel="label-input" [label]="'Ragione sociale*'" [placeholder]="'Inserisci ragione sociale'"
                customContainerlass="mb-8" type="text" >
            </std-input></div>
            <div class="pointer-events-none opacity-75"><std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                [(ngModel)]="completeData.codiceFiscale" [value]="completeData?.codiceFiscale" customLabel="label-input"
                [label]="'Codice fiscale*'" [placeholder]="'Inserisci codice fiscale'" customContainerlass="mb-8"
                type="text">
            </std-input></div>
            <div class="pointer-events-none opacity-75"><std-input [disabled]="true" labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                [(ngModel)]="completeData.partitaIva" [value]="completeData?.partitaIva" customLabel="label-input"
                [label]="'Partita IVA*'" [placeholder]="'Inserisci partita IVA'" customContainerlass="mb-8" type="text">
            </std-input></div>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                [(ngModel)]="completeData.numeroDipendenti" [value]="completeData?.numeroDipendenti"
                customLabel="label-input" [label]="'Numero Dipendenti(Opzionale)'"
                [placeholder]="'Inserisci numero dipendenti'" customContainerlass="mb-8" type="text">
            </std-input>
            <div>
                <div class="label-input !text-font24px">Fatturato ultimi 3 anni(Opzionale)</div>
                <div class="flex gap-5">
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[0].anno"
                    [value]="completeData.fatturatiUltimiTreAnni[0].anno" customLabel="label-input" [label]="'Anno'"
                    [placeholder]="'Inserisci anno'" customContainerlass="mb-8" type="number">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[0].valore"
                    [value]="completeData.fatturatiUltimiTreAnni[0].valore" customLabel="label-input"
                    [label]="'Fatturato'" [placeholder]="'Inserisci fatturato'" customContainerlass="mb-8"
                    type="number">
                </std-input>
            </div>
                <div class="flex gap-5">
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[1].anno"
                    [value]="completeData.fatturatiUltimiTreAnni[1].anno" customLabel="label-input" [label]="'Anno'"
                    [placeholder]="'Inserisci anno'" customContainerlass="mb-8" type="number">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[1].valore"
                    [value]="completeData.fatturatiUltimiTreAnni[1].valore" customLabel="label-input"
                    [label]="'Fatturato'" [placeholder]="'Inserisci fatturato'" customContainerlass="mb-8"
                    type="number">
                </std-input>
            </div>
            <div class="flex gap-5">
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[2].anno"
                    [value]="completeData.fatturatiUltimiTreAnni[2].anno" customLabel="label-input" [label]="'Anno'"
                    [placeholder]="'Inserisci anno'" customContainerlass="mb-8" type="number">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[2].valore"
                    [value]="completeData.fatturatiUltimiTreAnni[2].valore" customLabel="label-input"
                    [label]="'Fatturato'" [placeholder]="'Inserisci fatturato'" customContainerlass="mb-8"
                    type="number">
                </std-input>
            </div>
            </div>
            <div class="label-input !text-font30px flex gap-5 w-full">Sedi<div (click)="completeData.sedi.push({})"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    +</div>
            </div>
            @for (sede of completeData.sedi; track $index) {
                <div>
            <div class="label-input !text-font24px flex">Sede {{$index + 1}}<div (click)="removeSede($index)"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    -</div>
            </div>
            <std-select [filterable]="false" [currentValue]="sede.tipo ? {element:sede.tipo} : null"
                customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                customClassContaier="custom-select" class="w-[150px]" (onChangeValue)="
             sedeType($event,$index)
              " labelPosition="top" [label]="'Tipo'" [placeholder]="'Scegli tipo'" [data]="
              [{element:'LEGALE'},{element:'OPERATIVA'}]" bindLabel="element" bindValue="element"></std-select>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.indirizzo"
                [value]="sede.indirizzo" customLabel="label-input" [label]="'Indirizzo'"
                [placeholder]="'Inserisci indirizzo'" customContainerlass="mb-8" type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.cap" [value]="sede.cap"
                customLabel="label-input" [label]="'CAP'" [placeholder]="'Inserisci CAP'" customContainerlass="mb-8"
                type="number">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.citta" [value]="sede.citta"
                customLabel="label-input" [label]="'Citta'" [placeholder]="'Inserisci citta'" customContainerlass="mb-8"
                type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.provincia"
                [value]="sede.provincia" customLabel="label-input" [label]="'Provincia'"
                [placeholder]="'Inserisci provincia'" customContainerlass="mb-8" type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.stato" [value]="sede.stato"
                customLabel="label-input" [label]="'Stato'" [placeholder]="'Inserisci stato'" customContainerlass="mb-8"
                type="text">
            </std-input>
            </div>
            }
            <div class="label-input !text-font30px flex gap-5 w-full">Codici ateco<div (click)="completeData.ateco.push({})"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    +</div>
            </div>
            @for (ateco of completeData.ateco; track $index) {
            <div><div class="label-input !text-font24px flex">Ateco {{$index + 1}}<div (click)="removeAteco($index)"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    -</div>
            </div>
            <std-select [filterable]="false" [currentValue]="ateco.tipo ? {element:ateco.tipo} : null"
                customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                customClassContaier="custom-select" class="w-[150px]" (onChangeValue)="
             atecoType($event,$index)
              " labelPosition="top" [label]="'Tipo'" [placeholder]="'Scegli tipo'" [data]="
              [{element:'PREVALENTE'},{element:'SECONDARIO'}]" bindLabel="element" bindValue="element"></std-select>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="ateco.codice"
                [value]="ateco.codice" customLabel="label-input" [label]="'Codice'" [placeholder]="'Inserisci codice'"
                customContainerlass="mb-8" type="text">
            </std-input></div>
            }}
        </div>
        @if(role != 7){<div class="ml-auto w-full mt-5">
            <std-button (click)="confirmData()" id="button-login" size="sm"
                buttonClass="bg-quaternary rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Conferma</std-button>
        </div>}
        }
        </div>
        @if(myPlan && role != 7){
        <div class="min-w-[400px] pt-[20px] mt-10 border-t-[2px] border-primary aspect43:border-t-0 aspect43:mt-0">
            <div class="text-font26px aspect43:text-font63px text-center text-quaternary mt-[10px] mb-5">
                Il tuo piano
            </div>
            <div class=" border-quaternary mx-auto border-[2px] rounded-[20px] pt-2 px-5">
                <div class="text-quaternary text-font22px font-bold text-center">{{myPlan.name}}</div>
                <div class="italic text-font18px text-quaternary text-center">(€ {{myPlan.netprice}} + IVA)</div>
                <div class="text-quaternary text-font16px pb-5">
                    <div>- Consultazione bandi</div>
                    <div>- Newsletter di aggiornamento sui bandi in uscita e pubblicati</div>
                    <div>- Verifica preliminare dei requisiti di ammissibilità</div>
                    <div>- Virtual room preliminare</div>
                    <div>- N.1 virtual room con un esperto di finanza agevolata</div>
                </div>
            </div>
        </div>
        }
        
    </div>
    @if(showPassword){
        <std-modal  cardClass="!max-w-[90vw]" headerClass="bg-primary" [show]="showPassword" [closeOnOutside]="false"
        (close)="showPassword=false">
        <div class="text-tertiary text-large" header>{{t('modal.delete')}}</div>
        <div content>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
               [value]="oldPassword" [(ngModel)]="oldPassword"
                customLabel="label-input" [label]="'Vecchia password*'" [placeholder]="'Inserisci vecchia password'"
                customContainerlass="mb-8" type="text" >
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
               [value]="newPassword" [(ngModel)]="newPassword"
                customLabel="label-input" [label]="'Nuova password*'" [placeholder]="'Inserisci nuova password'"
                customContainerlass="mb-8" type="text" >
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
               [value]="confirmNewPassword" [(ngModel)]="confirmNewPassword"
                customLabel="label-input" [label]="'Conferma password*'" [placeholder]="'Inserisci conferma password'"
                customContainerlass="mb-8" type="text" >
            </std-input>
            <div class="text-primary text-medium">{{t('modal.confirmation')}}</div>
            <div class="mt-4 md:flex gap-4">
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary mb-4 md:mb-0" (click)="showPassword = false"
                    class="md:w-[200px]">{{t('modal.cancel')}}</std-button>
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="confirmChangePassword()"
                    class="md:w-[200px]">{{t('modal.confirm')}}</std-button>
            </div>
        </div>
    </std-modal>}
     
</div>